import React, { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import NextPage from "../assets/NextPage.png";
import Cover from "../assets/Cover.png";
import MoreInfo from "../assets/MoreInfo.svg"

const MovieCard = (props) => {
  const [active, setActive] = useState("");

  const handleClick = (id) => {
    setActive(id);
    if (active === id) {
      setActive(true);
    }
  };

  const handleChange = (id) => {
    if (active === id) {
      setActive(false);
    }
  };

  const setVoteClass = (vote) => {
    if (vote >= 8) {
      return "green";
    } else if (vote >= 6) {
      return "orange";
    } else {
      return "red";
    }
  };

  return (
    <div key={props.movie.id} className="col mb-4 card-group">
      <div className="card card-shadow">
        <div className={`movie-flip ${active ? "sm-movie-flip" : ""}`}>
          <div className="sm-flip">
            <Link to={"/" + props.movie.id}>
              {props.movie.poster_path ? (
                <img
                  className="card-img-top card-asm-top"
                  src={
                    "https://image.tmdb.org/t/p/original/" +
                    props.movie.poster_path}
                  alt={props.movie.title}
                ></img>
              ) : (
                <img
                  className="img-fluid placeholder-image"
                  src={Cover}
                  alt="placeholder"
                />
              )}
            </Link>
            <img
              className="flip-arrow"
              onClick={() => handleClick(props.movie.id)}
              src={MoreInfo}
              alt="flip-arrow"
            />
          </div>
          <div className="px-2 pb-5 bg-white movie-overview d-flex flex-column">
            <button
              type="button"
              className="close d-md-none card-button py-2"
              aria-label="Close"
              onClick={() => handleChange(props.movie.id)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 className="text-center text-justify font-weight-bold py-3 mb-2">
              Overview
            </h6>
            <h6 className="text-center lead"> {props.movie.overview}</h6>
          </div>
        </div>
        <div className="movie-body">
          <div className="card-font d-flex justify-content-between">
            <h6 className="text-size font-weight-bold">
              {props.movie.title}
            </h6>
            <h6
              className={`text-size-lg card-vote-color ${setVoteClass(
                props.movie.vote_average
              )}`}
            >
              {props.movie.vote_average.toFixed(1)}
            </h6>
          </div>

          <div className="card-font d-flex justify-content-between text-secondary">
            <p className="text-size2">Released Date: </p>
            <p className="text-size2">
              {moment(props.movie.release_date).format("MM/DD/YY")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
